export type AccessLevel = "admin" | "user" | "none";

export class BIM360ProjectService {
  name: "project_administration" | "document_management" = "document_management";
  access_level: AccessLevel = "user";

  public static fromAutodeskJSON(json: any): BIM360ProjectService
  {
      let service = new BIM360ProjectService();
      service.name = json.name;
      service.access_level = json.access_level;
      return service;
  }
}